import React from "react";

const TransactionIcon = ({ width, height, color }) => {
  return (
    <svg
      width="43"
      height="43"
      viewBox="0 0 43 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="21.5" cy="21.5" r="21" stroke="#C4C4C4" />
      <path
        d="M16 20L16 14C16 13.4696 16.2107 12.9609 16.5858 12.5858C16.9609 12.2107 17.4696 12 18 12L29 12C29.5304 12 30.0391 12.2107 30.4142 12.5858C30.7893 12.9609 31 13.4696 31 14L31 25C31 25.5304 30.7893 26.0391 30.4142 26.4142C30.0391 26.7893 29.5304 27 29 27L23 27"
        stroke="#00008B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 30L13 30L13 24"
        stroke="#00008B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 19L13 30"
        stroke="#00008B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TransactionIcon;
